import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import RouteManager from "../../../managers/RouteManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import { fetchExpenseCategories } from "../../../Redux/Slices/ExpenseCategorySlice";
import { selectExpenseLimits, fetchExpenseLimits } from "../../../Redux/Slices/ExpenseLimitSlice";
import ExpenseLimitPolicyService from "../../../services/ExpenseLimitPolicyService";
import ExpenseService from "../../../services/ExpenseService";
import Utility, { deepClone } from "../../../utility/Utility";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import { expenseLimitPolicyListColumnConfig, parseColumnConfig, parseVisibleColumnConfig } from "../../configs/config";
import AddExpenseLimitPopup from "./AddExpenseLimitPopup";
import { DKLabel, DKButton, DKIcons, removeLoader, showLoader, showToast, TOAST_TYPE, showAlert } from "deskera-ui-library";
import { useTranslation } from "react-i18next";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";



const ExpenseLimitList = (props) => {

  /**Constants */
  const history = useHistory();
  const { t } = useTranslation();
  const initialState = {
    columnData: [],
    rowData: [],
    originalData: [],
    filter: []
  };

  /**Hooks */
  const [expenseLimitListData, setExpenseLimitListData] = useState(initialState);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [filters, setFilters] = useState([]);
  const [expenseLimitPopupData, setExpenseLimitPopupData] = useState({
    isVisible: false,
    formData: {},
    isEdit: false
  });
  const [categories, setCategories] = useState([]);
  const [categoryPopUpData, setCategoryPopup] = useState({
    enable: false,
    categories: []
  });
  const [isLoading, setIsLoadingFlag] = useState(true);
  const [reload, setReload] = useState(false);
  /**Selectors */
  const expenseLimits = useSelector(selectExpenseLimits);

  /**Dispacther */
  const dispatch = useDispatch();

  useEffect(() => {
    RouteManager.setPresenter({ props: { ...props, history: history } });
    loadCatogeries();
    loadExpenseLimitList({
      params: {
        limit: 20,
        page: 0
      }
    });
    window.openCategoryList = (categories) => {
      setCategoryPopup({
        enable: true,
        categories: Utility.decodeJSON(categories)
      });
    }

    return () => {
      window.openCategoryList = null;
      setCurrentPage(1)
      ExpenseLimitPolicyService.apiConfig = null;
    }
  }, []);

  useEffect(() => {
    if (!Utility.isEmpty(expenseLimits)) {
      const { content, pageable, totalPages } = expenseLimits;
      const rowData = expenseLimitPolicyListColumnConfig(expenseLimits);
      const columnConfig = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_EXPENSE_LIMIT), TABLES.PEOPLE_EXPENSE_LIMIT));

      const data = {
        columnData: deepClone(columnConfig),
        rowData: rowData,
        filter: [],
        originalData: {}
      };
      setExpenseLimitListData(data);
      setCurrentPage(pageable);
      setTotalPageCount(totalPages);
      setIsLoadingFlag(false);
    }

    return () => {
      setExpenseLimitListData(initialState);
    }
  }, [expenseLimits, reload]);

  const loadCatogeries = async (apiConfig) => {
    ExpenseService.apiConfig = apiConfig;
    await dispatch(fetchExpenseCategories());
  }

  const loadExpenseLimitList = async (apiConfig) => {
    ExpenseLimitPolicyService.apiConfig = apiConfig;
    await dispatch(fetchExpenseLimits())
  }

  const onFilter = (dataList, queries) => {

  }

  const onRowDelete = (data) => {
    if (!Utility.isEmpty(data?.rowData)) {
      const payload = [data.rowData.id];
      showAlert(
        t("EXPENSE_LIMIT_POLICY_DELETE_HEADER"),
        t("EXPENSE_LIMIT_POLICY_DELETE_SUB_HEADER"),
        deleteConfirm(payload)
      );
    }
  }
  const deleteConfirm = (data) => [
    {
      title: "Cancel",
      className: "bg-gray1 border-m",
      onClick: () => removeLoader(),

    },
    {
      title: "Delete",
      className: "bg-red text-white ml-r",
      onClick: () => onDeleteExpenseLimit(data, true),
    },
  ];

  const onDeleteExpenseLimit = (payload, isReload) => {
    showLoader("Deleting Expense limit policy... Please wait");
    ExpenseLimitPolicyService.deleteExpensePolicy(payload).then((response) => {
      if (isReload) {
        loadExpenseLimitList({
          ...ExpenseLimitPolicyService.apiConfig,
          params: {
            limit: 20,
            page: 0
          }
        })
        loadCatogeries();
      }
      showToast("Expense Limit policy deleted successfully.", TOAST_TYPE.SUCCESS);
      removeLoader();
    }, (error) => {
      removeLoader();
      showToast("Error deleting Expense limit policy.", TOAST_TYPE.FAILURE);
    })
  }

  const onRowEdit = (data) => {
    if (data) {
      setExpenseLimitPopupData({
        isVisible: true,
        formData: data,
        isEdit: true
      });
    }
  }

  const showExpensePopup = () => {
    setExpenseLimitPopupData({
      isVisible: true,
      formData: {},
      isEdit: false
    });
  }

  const onPopupClose = (isReload) => {
    setExpenseLimitPopupData({
      isVisible: false,
      formData: {}
    });
    if (isReload) {
      loadExpenseLimitList({
        ...ExpenseLimitPolicyService.apiConfig,
        params: {
          limit: 20,
          page: 0
        }
      });
      loadCatogeries();
    }
  }

  const onCategoryPopClose = () => {
    setCategoryPopup({
      enable: false,
      categories: []
    });
  }

  return (
    <>
      <div className="column " style={{ height: '90%' }}>
        <div className="flex-1 position-relative" style={{ minHeight: "200px" }}>
          <DataGridHolderPayroll
            tableName={TABLES.PEOPLE_EXPENSE_LIMIT}
            displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_EXPENSE_LIMIT]}
            allowColumnEdit={false}
            allowColumnDelete={false}
            allowColumnShift={false}
            allowSearch={false}
            allowFilter={false}
            allowColumnAdd={false}
            allowRowAdd={false}
            refresh={false}
            allowDataExport={false}
            allowRowEdit={PermissionUtils.hasAccess(MODULE.EXPENSE_ADMIN_SETTING,[ACTION.EDIT])}
            showContextEdit={false}
            isActionEnabled={true}
            contextMenu={true}
            isMenuVisible={false}
            gridData={expenseLimitListData}
            filter={filters}
            currentPage={currentPage}
            totalPageCount={totalPageCount}
            onFilter={(dataList, queries) => {
              onFilter(dataList, queries);
            }}
            onRowDelete={(data) => {
              onRowDelete(data);
            }}
            onRowEdit={(data) => {
              onRowEdit(data);
            }}
            addButtonConfig={[{
              title: "+ Set Expense Limit Policy",
              className: "bg-app text-white ml-s",
              onClick: () => {
                showExpensePopup();
              }
            }]}
            onPaginationClick={(requestedPageNumber) => {
              loadExpenseLimitList({
                ...ExpenseLimitPolicyService.apiConfig,
                params: {
                  limit: 20,
                  page: requestedPageNumber - 1
                }
              })
            }}
            onRowOpenBtnHidden={false}
            updating={isLoading}
            onColumnShift={(data)=> setReload(!reload)}
            module={MODULE.EXPENSE_ADMIN_SETTING}
          />
        </div>
      </div>
      {expenseLimitPopupData?.isVisible &&
        <AddExpenseLimitPopup
          onClose={(isReload) => onPopupClose(isReload)}
          formData={expenseLimitPopupData.formData}
          isEdit={expenseLimitPopupData.isEdit}
        />}

      { categoryPopUpData.enable && (
        <>
          <div className=" transparent-background">
            <div className="p-h-r pt-r pb-m popup-window custom-popup-outer" style={{ padding: 0, maxWidth: "25%", width: "100%", overflow: "hidden" }} >

              <div className="row justify-content-between p-h-m p-v-s bg-gray2">
                <DKLabel text={"Expense Limit is Applicable to"} className="fs-l fw-m" />
                <DKButton icon={DKIcons.ic_close} onClick={() => onCategoryPopClose(false)} />
              </div>
              <div
                className=" parent-width p-m custom-popup-body"
              >
                {categoryPopUpData.categories.map((i, index) => {
                  return (
                    <>
                      <div className="pb-s">
                        <div className="row fs-m">
                          <div>{`${index + 1}. ${i?.expenseCategoryId?.name} `}</div>
                        </div>
                      </div>
                    </>
                  )
                })}
              </div>
            </div>
          </div>

        </>
      )}
    </>
  )



}

export default ExpenseLimitList;